import { render, staticRenderFns } from "./walletnote.vue?vue&type=template&id=4eee5a4f&"
import script from "./walletnote.vue?vue&type=script&lang=js&"
export * from "./walletnote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports